import { useAuthStore } from '@/stores/authStore';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';
import { PatientFileMark } from '@src/const/PatientFileMarks';
import { FeatureFlagType } from '@therame/shared';
import type { MingcuteIconName } from '@therame/ui';

export interface PatientFileMarkItem {
  title: string;
  route: string;
  icon: MingcuteIconName;
  mark: PatientFileMark;
  readonly isDisabledByFeatureToggle: boolean;
}

export const patientFileMarkItems: PatientFileMarkItem[] = [
  {
    title: 'Übersicht',
    route: '#',
    icon: 'icon-[mingcute--user-1-line]',
    mark: PatientFileMark.GENERAL,
    isDisabledByFeatureToggle: false,
  },
  {
    // Programm + Statistiken merged into one "Programme" tab (list above statistics).
    title: 'Programme',
    route: '#',
    icon: 'icon-[mingcute--barbell-line]',
    mark: PatientFileMark.PROGRAM,
    isDisabledByFeatureToggle: false,
  },
  {
    title: 'Befund',
    route: '#',
    icon: 'icon-[mingcute--edit-4-line]',
    mark: PatientFileMark.DIAGNOSIS,
    get isDisabledByFeatureToggle() {
      return !useFeatureToggleStore().isAnamnesisEnabled;
    },
  },
  {
    title: 'Dokumentation',
    route: '#',
    icon: 'icon-[mingcute--documents-line]',
    mark: PatientFileMark.DOCUMENTATION,
    get isDisabledByFeatureToggle() {
      return !useAuthStore().isFeatureFlagEnabled(FeatureFlagType.DOCUMENTATION);
    },
  },
];
